import { render, staticRenderFns } from "./ReportEnquiries.vue?vue&type=template&id=49235ba6&scoped=true&"
import script from "./ReportEnquiries.vue?vue&type=script&lang=js&"
export * from "./ReportEnquiries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49235ba6",
  null
  
)

export default component.exports